import {Outlet, useLocation} from 'react-router-dom';

import JsonData from '../../data/data.json';
import {FooterScreen} from '../FooterScreen';
import {Navbar} from '../Navbar';

const LayoutComponent = () => {
  const location = useLocation();

  const hideFooterPaths = ['/cart', '/checkout', '/userhistory'];

  return(
    <div className={'flex flex-col min-h-screen'}>
      <Navbar />
      <div className={'pt-20 lg:pt-40 xl:pt-36'}>
        <Outlet />
      </div>
      {!hideFooterPaths.includes(location.pathname) && <FooterScreen  data={JsonData.Footer} />}
    </div>
  );
};

export default LayoutComponent;
